import React, { useMemo } from "react";
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Font, Image } from "@react-pdf/renderer";
import { useAuthContext } from "lib/context/AuthContextContext/AuthContext";
import { useTranslation } from "react-i18next";
import Icon from "components/atoms/icon/Icon";
import { IconType } from "lib/helpers/constants/iconTypes";
// Styles
const styles = StyleSheet.create({
    page: { padding: 40, fontSize: 10, fontFamily: "InterMedium", gap: 24 },
    row: { flexDirection: "row", justifyContent: "space-between", color: '#282D46', fontWeight: 500, gap: 50 },
    bold: { fontFamily: "InterBold", color: '#282D46', },
    title: { fontSize: 15, fontFamily: "InterBold", color: '#282D46' },
    line: { borderBottom: "1px solid #DCDCDC" },
});

Font.register({
    family: 'InterMedium',
    src: '/font/Inter-Medium.ttf',
})

Font.register({
    family: 'InterBold',
    src: '/font/Inter-Bold.ttf',
})

Font.register({
    family: 'InterSemiBold',
    src: '/font/Inter-SemiBold.ttf',
})




// PDF Component
const SalarySlipPDF = ({ salaryData, user }: { salaryData: any, user: any }) => (

    <Document>
        <Page style={styles.page}>
            <View style={{ position: 'absolute', top: 40, right: 40 }}>
                <Image style={{ width: 100, height: 100, objectFit: 'contain', objectPositionY: 0 }} src={`${process.env.REACT_APP_API_URL}company-logo/${user.company.logo}`} />
            </View>
            <View style={{ gap: 4, color: '#282D46', fontWeight: 500 }}>
                <Text>{user.company.name} GmbH</Text>
                <Text>{user.company.address}</Text>

            </View>
            <Text style={[styles.title,{paddingTop:10}]}>{salaryData.title}</Text>


            <View style={{ gap: 4, color: '#282D46', fontWeight: 500 }}>
                <Text>Mr. {salaryData.name}</Text>
                <Text>{salaryData.address}</Text>
                <Text style={{ marginTop: 5, fontFamily: 'InterSemiBold' }}>AHV Nr. {salaryData.ahvNumber}</Text>
            </View>
            <View style={{ gap: 7 }}>
                <View style={styles.row}>
                    <Text>Monatslohn:</Text>
                    <Text style={{ marginLeft: 'auto' }}>
                        CHF
                    </Text>
                    <Text style={{ width: 50, alignItems: 'flex-end', textAlign: 'right' }}>
                        {Number(salaryData.fixedSalary).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </Text>
                </View>
                <View style={styles.row}>
                    <Text>Kommission:</Text>
                    <Text style={{ marginLeft: 'auto' }}>
                        CHF
                    </Text>
                    <Text style={{ width: 50, alignItems: 'flex-end', textAlign: 'right' }}>
                        {Number(salaryData.commissions).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </Text>
                </View>
                {salaryData?.bonuse !== 0 && (
                    <View style={styles.row}>
                        <Text>Bonuse:</Text>
                        <Text style={{ marginLeft: 'auto' }}>
                            CHF
                        </Text>
                        <Text style={{ width: 50, alignItems: 'flex-end', textAlign: 'right' }}>
                            {Number(salaryData.bonuse).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </Text>
                    </View>
                )}
                <View style={[styles.row, { marginBottom: 10 }]}>
                    <Text style={styles.bold}>Bruttolohn:</Text>
                    <Text style={{ marginLeft: 'auto' }}>
                        CHF
                    </Text>
                    <Text style={{ width: 50, alignItems: 'flex-end', textAlign: 'right' }}>
                        {Number(salaryData.baseSalary).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </Text>
                </View>


                {/* <View style={{ marginVertical: 5 }}>
                    <Text style={{ fontFamily: 'InterSemiBold', color: '#282D46' }}>Sozialversicherungskosten</Text>
                </View> */}
                {salaryData.socialInsurances.map((item: any, index: any) => (
                    <View style={styles.row} key={index}>
                        <Text>{item.name}:</Text>
                        <Text style={{ marginLeft: 'auto' }}>
                            {item.percentage}
                        </Text>
                        <Text>
                            CHF
                        </Text>
                         <Text style={{ width: 50, alignItems: 'flex-end', textAlign: 'right' }}>
                            {Number(item.amount).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </Text>
                    </View>
                ))}

                <View style={styles.row}>
                    <Text style={styles.bold}>Totale Abzüge:</Text>
                    <Text style={{ marginLeft: 'auto' }}>
                        CHF
                    </Text>
                    <Text style={{ width: 50, alignItems: 'flex-end', textAlign: 'right' }}>
                        {Number(salaryData.totalSocialInsurance).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </Text>
                </View>
            </View>
            <View style={{ gap: 7 }}>
                <View style={styles.row}>
                    <Text>Nettolohn:</Text>
                    <Text style={{ marginLeft: 'auto' }}>
                        -
                    </Text>
                    <Text >
                        CHF
                    </Text>
                    <Text style={{ width: 50, alignItems: 'flex-end', textAlign: 'right' }}>
                        {Number(salaryData.netSalary).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </Text>
                </View>
                <View style={styles.row}>
                    <Text>Spesen:</Text>
                    <Text style={{ marginLeft: 'auto' }}>
                        -
                    </Text>
                    <Text >
                        CHF
                    </Text>
                    <Text style={{ width: 50, alignItems: 'flex-end', textAlign: 'right' }}>
                        {Number(salaryData.compensation).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </Text>
                </View>

                <View style={styles.row}>
                    <Text style={styles.bold}>Nettolohn inkl. Spesen:</Text>
                    <Text style={{ marginLeft: 'auto' }}>
                        -
                    </Text>
                    <Text >
                        CHF
                    </Text>
                    <Text style={{ width: 50, alignItems: 'flex-end', textAlign: 'right' }}>
                        {Number(salaryData.netSalaryWithCompensation).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </Text>
                </View>
            </View>
            <View style={{ gap: 7 }}>
                {salaryData.otherExpenses.length > 0 && (

                    <View style={{ paddingBottom: 5, color: '#282D46', fontFamily: 'InterSemiBold' }}>
                        <Text>Sonstige Ausgaben:</Text>
                    </View>
                )}
                {salaryData.otherExpenses.map((item: any, index: any) => (
                    <View style={styles.row} key={index}>
                        <Text>{item.name}:</Text>
                        <Text style={{ marginLeft: 'auto' }}>
                            {item.percentage}
                        </Text>
                        <Text>
                            CHF
                        </Text>
                        <Text style={{ width: 50, alignItems: 'flex-end', textAlign: 'right' }}>{item.amount}</Text>
                    </View>
                ))}
            </View>
            <View style={styles.row}>
                <Text style={styles.bold}>Ausbezahlter Lohn</Text>
                <Text style={{ marginLeft: 'auto' }}>
                    CHF
                </Text>
                <Text style={{ width: 50, alignItems: 'flex-end', textAlign: 'right' }}>
                    {Number(salaryData.totalPaid).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </Text>
            </View>

            {/* <View style={{ gap: 7 }}>
                <Text style={[styles.bold, { fontSize: 13 }]}>Notice:</Text>
                <Text style={{ color: '#282D46' }}>
                    Please review your salary statement and report any discrepancies to buchhaltung@dl-finance.ch. Changes to address, salary account, or marital status must be reported.
                </Text>
            </View> */}
            <View style={{ gap: 7 }}>
                <Text style={[styles.bold, { fontSize: 10 }]}>Mitteilung:</Text>
                <View style={{ color: '#282D46', flexDirection: 'row' }}>
                    <Text>Bitte Lohabrechnung kontrollieren und allfällige Abweichungen an {user.company.email} melden.
                        Adresse-, Lohnkonto- oder Zivilstandsänderungen müssen gemeldet werden.</Text>

                </View>
                <View style={{ color: '#282D46', gap:7 }}>
                    <Text style={[styles.bold]}>Auszahlung:</Text>
                    <Text>CHF {Number(salaryData.totalPaid).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}  auf Bankkonto {salaryData.bankAccount}</Text>
                </View>
            </View>
            {/* <View>
                <Text style={{ textAlign: 'center', fontSize: 16, fontFamily: 'InterSemiBold',marginTop:20 }}>Fair. Kompetent. Lokal.</Text>
            </View> */}
        </Page>
    </Document >
);



// Main Component
const SalarySlip = ({ data }: { data: any }) => {
    
    const FixedSalary = useMemo(() => {
        if (data.salary_frequency !== "monthly") {
            return 0;
        }

        return data.fixed_salary;
    }, [data]);

    const { t } = useTranslation()

    const { user } = useAuthContext();
    

    const totalBruteSalary = FixedSalary + data.totalAmountOtherBonusesMonthly + data.provisioned_total - data.canceled_total;

    let totalSocialInsurance = 0;  // Initialize the variable outside of the map

    const socialInsurances = data.expenses
        .filter((item: any) => item.type === "Social Insurance")
        .map((item: any) => {
            const amount = item.measurement_type === 'CHF'
                ? item.amount
                : (totalBruteSalary * (item.amount / 100)).toFixed(2);

            // Update totalSocialInsurance
            totalSocialInsurance += parseFloat(amount);

            return {
                name: item.name,
                percentage: item.measurement_type === '%' ? item.amount + '%' : '-',
                amount: amount,
            };
        });

    let totalOtherExpenses = 0;

    const otherExpenses = data.expenses
        .filter((item: any) => item.type === "Other Expenses")
        .map((item: any) => {
            const amount = item.measurement_type === 'CHF'
                ? parseFloat(item.amount)
                : ((totalBruteSalary - totalSocialInsurance + data.total_compensation_amount) * (parseFloat(item.amount) / 100)).toFixed(2);


            totalOtherExpenses += parseFloat(amount as any);

            return {
                name: item.name,
                percentage: item.measurement_type === '%' ? item.amount + '%' : '-',
                amount: amount,
            };
        });

    const currentMonth = new Date().toLocaleString('de-DE', { month: 'long' });
    const currentYear = new Date().getFullYear();

    const salaryData = {
        title: 'Monatslohn ' + t(currentMonth) + ' ' + currentYear,
        name: data.userData.name + ' ' + data.userData.last_name,
        address: data.userData.user_information.address + ' ' + data.userData.user_information.zip_code + ' ' + data.userData.user_information.city,
        ahvNumber: data.userData.user_information.ahv_number,
        fixedSalary: FixedSalary.toFixed(2),
        commissions: data.provisioned_total - data.canceled_total,
        bonuse: data.totalAmountOtherBonusesMonthly,
        baseSalary: totalBruteSalary.toFixed(2),
        socialInsurances: socialInsurances,
        totalSocialInsurance: totalSocialInsurance.toFixed(2),
        netSalary: totalBruteSalary - totalSocialInsurance,
        compensation: data.total_compensation_amount.toFixed(2),
        netSalaryWithCompensation: (totalBruteSalary - totalSocialInsurance + data.total_compensation_amount).toFixed(2),
        otherExpenses: otherExpenses,
        totalPaid: (totalBruteSalary - totalSocialInsurance + data.total_compensation_amount - totalOtherExpenses).toFixed(2),
        bankAccount: data.userData.user_information.bank_number + ', ' + data.userData.user_information.bank_name
    };




    return (
        <div>


            <PDFDownloadLink
            document={<SalarySlipPDF salaryData={salaryData} user={user} />}
            fileName="Salary_Slip.pdf"
            >
            {({ loading }) => (
                <button
                type="button"
                className="inline-flex items-center gap-2 px-4 py-2 bg-[--theme] text-white text-sm font-medium rounded-md transition duration-200"
                >
                <Icon iconType={IconType.DOWNLOAD_PDF_ICON} color="#ffffff"/>

                {loading ? t('Preparing...') : t('Salary Slip')}
                </button>
            )}
            </PDFDownloadLink>
        </div>
    );
};

export default SalarySlip;
